<template>
  <!-- 간편입점 완료 페이지 -->
  <div>
    <v-container pa-0 fluid>
      <div class="complete-title">간편 입점 신청 완료</div>
      <div class="complete-border"></div>
      <div class="complete-content">
        <div class="complete-content-txt-1">신청이 완료되었습니다.</div>
        <div class="complete-content-txt-2">
          담당자가 사장님께 직접 연락을 드리고
          <div class="mobile-space"></div>
          입점 신청 절차를 도와드리겠습니다.
        </div>
        <div class="complete-content-txt-3">
          <img src="@/assets/imgs/daeguro_icon.png" class="daeguro" />
          <img src="@/assets/imgs/mal_2.png" class="mal" />
          <img src="@/assets/imgs/mal_small.png" class="mal_small" />
        </div>
      </div>
      <div class="complete-how-to-block-all">
        <div class="complete-how-to-block">
          <div class="complete-how-to-block-title-1">
            ㆍ법인사업자 준비 서류
          </div>
          <div>
            <div class="complete-how-to-block-left">
              ① 법인등기부등본 <br />
              ② 메뉴와 가격이 기입된 메뉴판<br />
            </div>
            <div class="complete-how-to-block-right">③ 로고 이미지<br /></div>
          </div>
        </div>
        <div class="complete-how-to-block" id="complete-how-to-block-1">
          <div class="complete-how-to-block-title-2">
            ㆍ개인사업자 준비 서류
          </div>
          <div>
            <div class="complete-how-to-block-left">
              ① 메뉴와 가격이 기입된 메뉴판<br />
              ② 로고 이미지
            </div>
            <div class="complete-how-to-block-right"></div>
          </div>
        </div>
      </div>
      <div class="complete-center-block">
        <div class="complete-center-img">
          <img src="@/assets/imgs/headset.png" class="headset" />
        </div>
        <div class="complete-center-right">
          <div class="complete-center-txt-1">
            고객센터
            <span class="complete-center-txt-1-2"> 1661-3773 </span>
          </div>
          <div class="complete-center-txt-2">
            - 평일 오전 10시 ~ 오후 8시
            <br />
            - 토요일 오전 10시 ~ 오후 7시
            <br />
            - 일요일/공휴일 휴무
          </div>
        </div>
      </div>
      <div></div>
      <br />
    </v-container>
  </div>
</template>

<script>
export default {
  async created() {
    window.scrollTo(0, 0);
    window.karrotPixel.track("SubmitApplication");
  },
};
</script>

<style scoped>
div {
  /* border: red solid 2px; */
  font-family: "PretendardRegular";
}

.container {
  font-family: "PretendardRegular";
}

/*
##Device = Desktops
##Screen = 1281px to higher resolution desktops
##Device = 데스크탑
##Screen = 1281px 이상 해상도 데스크탑
*/

@media (min-width: 1281px) {
  .container {
    width: 1170px !important;
  }

  .complete-center-img,
  .complete-center-right {
    float: left;
  }
  .complete-title {
    height: 59px;
    font-family: "PretendardRegular";
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: left;
    color: #333333;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .complete-border {
    height: 1px;
    background-color: #333333;
  }
  .complete-content {
    margin-top: 50px;
    text-align: center;
  }
  .complete-content-txt-1 {
    font-family: "PretendardRegular";
    font-size: 28px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.46;
    letter-spacing: -0.56px;
    text-align: center;
    color: #333333;
  }
  .complete-content-txt-2 {
    font-family: "PretendardRegular";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: center;
    color: #333333;
    margin-top: 10px;
  }

  .complete-content-txt-3 {
    margin-top: 36px;
  }

  .daeguro {
    width: 84px;
    margin-right: 7px;
  }

  .mal {
    width: 470px;
  }

  .headset {
    width: 138px;
  }

  .complete-how-to-block-all {
    margin-top: 70px;
  }

  .complete-how-to-block-all::after {
    display: block;
    content: "";
    clear: both;
  }

  .complete-center-block {
    width: 100%;
    height: 186px;
    margin: 50px 0 0;
    padding: 24px 24px 40px;
    border: solid 1px #e6e6e6;
    background-color: #f2f2f2;
  }

  .complete-center-right {
    margin-top: 33px;
    margin-left: 39px;
  }

  .complete-center-txt-1 {
    font-family: "PretendardRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #333333;
  }

  .complete-center-txt-1-2 {
    font-family: "RobotoRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #ff3333;
  }

  .complete-center-txt-2 {
    font-family: "PretendardRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
    margin-top: 1px;
  }

  .complete-how-to-1 {
    font-family: "PretendardRegular";
    margin-top: 40px;
  }
  .complete-how-to-text-1 {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }
  .complete-how-to-text-2 {
    margin-top: 8px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }
  .complete-how-to-1-2 {
    margin-top: 30px;
  }
  .complete-how-to-block {
    float: left;
    width: 48%;
    height: 155px;
    padding: 28px 101px 28px 28px;
    border: solid 2px #01c9ff;
  }
  .complete-how-to-block-left,
  .complete-how-to-block-right {
    float: left;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: left;
    color: #333333;
    margin-top: 20px;
  }
  .complete-how-to-block-title-1,
  .complete-how-to-block-title-2 {
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
  }
  .complete-how-to-block-title-1 {
    color: #01c9ff;
  }
  .complete-how-to-block-right {
    margin-left: 24%;
  }
  #complete-how-to-block-1 {
    border-color: black;
    float: right;
  }
  .mobile-space {
    display: none;
  }
  .mal_small {
    display: none;
  }
  .tablet-space {
    display: none;
  }
}

/*
##Device = Laptops, Desktops
##Screen = B/w 1025px to 1280px
##Device = 랩탑, 데스크탑
##Screen = 1025px에서 1280px 사이
*/

@media (min-width: 768px) and (max-width: 1280px) {
  .container {
    width: 586px !important;
  }

  .complete-center-img,
  .complete-center-right {
    float: left;
  }
  .complete-title {
    height: 59px;
    font-family: "PretendardRegular";
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: center;
    color: #333333;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .complete-border {
    height: 1px;
    background-color: #333333;
  }
  .complete-content {
    margin-top: 50px;
    text-align: center;
  }
  .complete-content-txt-1 {
    font-family: "PretendardRegular";
    font-size: 28px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.46;
    letter-spacing: -0.56px;
    text-align: center;
    color: #333333;
  }
  .complete-content-txt-2 {
    font-family: "PretendardRegular";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: center;
    color: #333333;
    margin-top: 10px;
  }

  .complete-content-txt-3 {
    margin-top: 36px;
  }

  .daeguro {
    width: 84px;
    margin-right: 7px;
  }

  .mal {
    width: 470px;
  }

  .headset {
    width: 138px;
  }

  .complete-how-to-block-all {
    margin-top: 70px;
  }

  .complete-how-to-block-all::after {
    display: block;
    content: "";
    clear: both;
  }

  .complete-center-block {
    width: 100%;
    height: 186px;
    margin: 50px 0 60px;
    padding: 24px 11px 40px;
    border: solid 1px #e6e6e6;
    background-color: #f2f2f2;
  }

  .complete-center-right {
    margin-top: 24px;
    margin-left: 11px;
  }

  .complete-center-txt-1 {
    font-family: "PretendardRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #333333;
  }

  .complete-center-txt-1-2 {
    font-family: "RobotoRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #ff3333;
  }

  .complete-center-txt-2 {
    font-family: "PretendardRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }

  .complete-how-to-1 {
    font-family: "PretendardRegular";
    margin-top: 40px;
  }
  .complete-how-to-text-1 {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }
  .complete-how-to-text-2 {
    margin-top: 8px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }
  .complete-how-to-1-2 {
    margin-top: 30px;
  }
  .complete-how-to-block {
    float: left;
    width: 586px;
    height: 155px;
    padding: 28px 37px 28px 28px;
    border: solid 2px #01c9ff;
  }
  .complete-how-to-block-left,
  .complete-how-to-block-right {
    float: left;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: left;
    color: #333333;
    margin-top: 20px;
  }
  .complete-how-to-block-title-1,
  .complete-how-to-block-title-2 {
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
  }
  .complete-how-to-block-title-1 {
    color: #01c9ff;
  }
  .complete-how-to-block-right {
    margin-left: 24%;
  }
  #complete-how-to-block-1 {
    border-color: black;
    float: right;
    margin-top: 20px;
  }
  .mobile-space {
    display: none;
  }
  .mal_small {
    display: none;
  }
}

@media (max-width: 767px) {
  .container {
    width: 324px !important;
  }

  .complete-center-img,
  .complete-center-right {
    float: left;
  }
  .complete-title {
    font-family: "PretendardRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.48px;
    text-align: center;
    color: #333333;
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .complete-border {
    height: 1px;
    background-color: #333333;
  }
  .complete-content {
    margin-top: 50px;
    text-align: center;
  }
  .complete-content-txt-1 {
    font-family: "PretendardRegular";
    font-size: 28px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.46;
    letter-spacing: -0.56px;
    text-align: center;
    color: #333333;
  }
  .complete-content-txt-2 {
    font-family: "PretendardRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: center;
    margin-top: 10px;
    color: #333333;
  }

  .complete-content-txt-3 {
    margin-top: 36px;
  }

  .daeguro {
    display: none;
  }

  .mal {
    width: 470px;
  }

  .headset {
    width: 84px;
  }

  .complete-how-to-block-all {
    margin-top: 52px;
  }

  .complete-how-to-block-all::after {
    display: block;
    content: "";
    clear: both;
  }

  .complete-center-block {
    width: 100%;
    height: 120px;
    margin: 50px 0 60px;
    padding: 16px 0 40px;
    border: solid 1px #e6e6e6;
    background-color: #f2f2f2;
  }

  .complete-center-right {
    margin-top: -1px;
    margin-left: 3px;
  }

  .complete-center-txt-1 {
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
    color: #333333;
  }

  .complete-center-txt-1-2 {
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
    color: #ff3333;
  }

  .complete-center-txt-2 {
    font-family: "PretendardRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }

  .complete-how-to-1 {
    font-family: "PretendardRegular";
    margin-top: 40px;
  }
  .complete-how-to-text-1 {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }
  .complete-how-to-text-2 {
    margin-top: 8px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }
  .complete-how-to-1-2 {
    margin-top: 30px;
  }
  .complete-how-to-block {
    float: left;
    width: 324px;
    height: 170px;
    padding: 28px 37px 28px 28px;
    border: solid 2px #01c9ff;
  }
  .complete-how-to-block-left,
  .complete-how-to-block-right {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: left;
    color: #333333;
    margin-top: 20px;
  }
  .complete-how-to-block-title-1,
  .complete-how-to-block-title-2 {
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
  }
  .complete-how-to-block-title-1 {
    color: #01c9ff;
  }
  .complete-how-to-block-right {
    /* margin-left: 24%; */
    margin-top: 0;
  }
  #complete-how-to-block-1 {
    border-color: black;
    float: right;
    margin-top: 20px;
  }
  .mal {
    display: none;
  }
  .mal_small {
    width: 324px;
  }
  .tablet-space {
    display: none;
  }
}
</style>
